export const LOGIN_FAILED = 'LOGIN_ATTEMPT' as 'LOGIN_ATTEMPT'
export const LOGIN_REQUIRED = 'LOGIN_REQUIRED' as 'LOGIN_REQUIRED'
export const LOGIN_VERIFIED = 'LOGIN_VERFIED' as 'LOGIN_VERFIED'
export const LOGOUT = 'LOGOUT' as 'LOGOUT'
